const light = {
  primaryColor: '#161A30',
  secondryColor: '#0088cc',
  secondryColorOpacity: '#0088cc50',
  drawerBackground: '#FBF9F1',
  drawerHeader: '#0088cc',
  line: '#F3F8FF',
  container: '#EEF5FF',
  menu: '#0088cc',
  drawerHeaderBox: '#fff',
  color01: '#0088cc',
  color02: '#fff',
  color03: '#0088cc',
  white: '#fff',
  black: '#222',
  blue: '#40A2E3',
  secondBlue: '#40A2E3',
  reciveChat: '#fff',
  inputTollbar: '#AFC4D5',
  lastMessage: '#B6BBC4',
  groupInput: '#a4d3ef',
  bioInput: '#fff',
  bottomSheetColor: '#fff',
  textLoad: '#fff',
  leftBubble: '#000',
  searchBack: '#fff',
  contactSelect: '#a4d3ef55',
  dropdown: 'rgba(153, 190, 217,0.8)',
  dropdownContent: 'rgba(153, 190, 217,0.9)',
};

const dark = {
  primaryColor: '#e4e6eb',
  secondryColor: '#b0b3b8',
  secondryColorOpacity: '#b0b3b850',
  drawerBackground: '#3a3b3c',
  drawerHeader: '#18191a',
  line: '#3D3B40',
  container: '#242526',
  menu: '#3a3b3c',
  drawerHeaderBox: '#333',
  color01: '#fff',
  color02: '#45474B',
  color03: '#333',
  white: '#fff',
  black: '#222',
  blue: '#40A2E3',
  secondBlue: '#b0b3b850',
  reciveChat: '#006666',
  inputTollbar: '#3a3b3c',
  lastMessage: '#B6BBC4',
  groupInput: '#505153',
  bioInput: '#333',
  bottomSheetColor: '#505153',
  textLoad: '#45474B',
  leftBubble: '#fff',
  searchBack: '#3a3b3c',
  contactSelect: '#3a3b3c66',
  dropdown: 'rgba(0, 12, 12,0.9)',
  dropdownContent: 'rgba(58, 59, 60,0.9)',
};

const rose = {
  primaryColor: '#161A30',
  secondryColor: '#D7456E',
  secondryColorOpacity: '#D7456E50',
  drawerBackground: '#E0AED0',
  drawerHeader: '#D7456E',
  line: '#F3F8FF',
  container: '#de8db2',
  menu: '#D7456E',
  drawerHeaderBox: '#fff',
  color01: '#D7456E',
  color02: '#D7456E',
  color03: '#D7456E',
  white: '#fff',
  black: '#222',
  blue: '#40A2E3',
  secondBlue: '#FF90BC',
  reciveChat: '#fff',
  inputTollbar: '#FF90BC',
  lastMessage: '#818FB4',
  groupInput: '#de8db2',
  bioInput: '#fff',
  bottomSheetColor: '#fff',
  textLoad: '#fff',
  leftBubble: '#000',
  searchBack: '#fff',
  contactSelect: '#D7456E33',
  dropdown: 'rgba(251, 229, 236,0.9)',
  dropdownContent: 'rgba(215, 69, 110,0.9)',
};

const white = {
  primaryColor: '#000',
  secondryColor: '#000',
  secondryColorOpacity: '#ddd',
  drawerBackground: '#E0AED0',
  drawerHeader: '#ddd',
  line: '#ddd',
  container: '#fff',
  menu: '#fff',
  drawerHeaderBox: '#eee',
  color01: '#000',
  color02: '#eee',
  color03: '#eee',
  white: '#000',
  black: '#222',
  blue: '#40A2E3',
  secondBlue: '#eee',
  reciveChat: '#ddd',
  inputTollbar: '#fff',
  lastMessage: '#818FB4',
  groupInput: '#fff',
  bioInput: '#fff',
  bottomSheetColor: '#fff',
  textLoad: '#fff',
  leftBubble: '#000',
  searchBack: '#fff',
  contactSelect: '#ddd',
  dropdown: 'rgba(238, 238, 238,0.9)',
  dropdownContent: 'rgba(255, 255, 255,0.9)',
};

const colors = {
  light,
  dark,
  rose,
  white,
};

export default colors;
